export type ISegmentType = 'all';
export type ISegmentFilterType = 'all' | 'custom' | 'testing';
export type IVisitorMessageType = 'email' | 'browse' | 'sms' | 'whatsapp' | 'rcs'; // TODO why is browse here?!
export type IOffsiteCampaignType = 'cartAbandonment' | 'browseAbandonment' | 'bulkRetargeting';
export type State = 'ACTIVE' | 'INACTIVE' | 'DELETED' | 'TESTING' | 'MIGRATION' | 'SCHEDULED' | 'FINISHED';

export interface LifeCycle {
  state?: State;
  startTime?: number | null;
  endTime?: number | null;
}

export interface ICycle {
  id: string;
  messageType: IVisitorMessageType;
  delay: number;
  subjectLineId: string;
  templateId: string;
  name?: string;
}

export interface IPercentageSplit {
  id: string;
  name: string;
  percentage: number;
  isDefault?: boolean;
  cycles: ICycle[];
}

export interface ISegmentFilter {
  id: string;
  type: ISegmentFilterType;
  include: boolean;
  value: string;
  options: string[];
  comparison: string;
  channel?: string;
}

export interface ISegment {
  id: string;
  name: string;
  splitTestName?: string;
  type: ISegmentType;
  splitTestId?: string;
  segmentFilters: ISegmentFilter[];
  percentageSplits: IPercentageSplit[];
}

export interface IOffsiteCampaign extends LifeCycle {
  id?: string;
  name?: string;
  type?: IOffsiteCampaignType;
  siteId?: string;
  splitTestEndDate?: number | null;
  splitTestStartDate?: number | null;
  createdAt?: number;
  createdById?: string;
  updatedAt?: number;
  updatedById?: string;
  suppressTimeWindows: SuppressTimeWindow[];
  segments: ISegment[];
  lastEditingComment?: string;
  minimumBrowseTime?: number;
  version?: string;
  lookbackPeriod?: number;
}

export interface SuppressTimeWindow {
  suppressTimeStart: number;
  suppressTimeEnd: number;
  dayOfTheWeek: DayOfTheWeek;
}

enum DayOfTheWeek {
  Monday = 1,
  Tuesday,
  Wednesday,
  Thursday,
  Friday,
  Saturday,
  Sunday,
}

export function addVersion2ToCampaign(campaign: IOffsiteCampaign) {
  campaign.version = 'v2';
  return campaign;
}

export function sortAndGenerateCyclesNames(campaign: IOffsiteCampaign) {
  for (let i = 0; i < campaign.segments.length; i++) {
    for (let j = 0; j < campaign.segments[i].percentageSplits.length; j++) {
      const sortedCycles = campaign.segments[i].percentageSplits[j].cycles.sort((a, b) => a.delay - b.delay);
      campaign.segments[i].percentageSplits[j].cycles = sortedCycles;
      for (let k = 0; k < campaign.segments[i].percentageSplits[j].cycles.length; k++) {
        campaign.segments[i].percentageSplits[j].cycles[k].name = 'Cycle ' + (k + 1);
      }
    }
  }
  return campaign;
}
export function addDefaultToFirstVariant(campaign: IOffsiteCampaign) {
  for (let i = 0; i < campaign.segments.length; i++) {
    campaign.segments[i].percentageSplits[0].isDefault = true;
  }
  return campaign;
}

export function isVariantControlGroup(split: IPercentageSplit): boolean {
  if (split.cycles.length < 1) {
    return true;
  }

  return false;
}

// Count the number of control groups in the given segment
// If the current segment has multiple control groups, return true
export function segmentHasMultipleControlGroups(segment: ISegment): boolean {
  let count = 0;

  for (const ps of segment.percentageSplits) {
    if (isVariantControlGroup(ps)) {
      count++;
    }
  }

  if (count > 1) {
    return true;
  }
}

// OFFSITE-3177 It was possible to get a campaign in a state where two segments shared the same split test ID
// This is NOT GOOD - as a failsafe, this function is used to check to see if a campaign is in this state.
export function campaignHasSharedSplitTestIds(campaign: IOffsiteCampaign): boolean {
  const listOfSplitTestIds: string[] = [''];

  for (const segment of campaign.segments) {
    if (segment.splitTestId) {
      // If we have already encountered this split test ID elsewhere in the campaign
      if (listOfSplitTestIds.includes(segment.splitTestId)) {
        return true;
      }
      listOfSplitTestIds.push(segment.splitTestId);
    }
  }
  return false;
}

// Determine if at least one segment has multiple control groups
// Iterate over the segments, and when we see a segment with multiple control groups, immediately return true
export function campaignHasMultipleControlGroups(campaign: IOffsiteCampaign): boolean {
  for (const s of campaign.segments) {
    const result = segmentHasMultipleControlGroups(s);

    if (result === true) {
      return true;
    }
  }

  return false;
}

export function isVariantDefault(split: IPercentageSplit, splits: IPercentageSplit[]): boolean {
  if (splits[0].name === split.name) {
    return true;
  }

  return false;
}

export function segmentHasSplitTest(length: number): boolean {
  return length > 1;
}

export function removeDanglingSplitTestIds(campaign: IOffsiteCampaign) {
  for (let i = 0; i < campaign.segments.length; i++) {
    if (
      // If we have a split test ID for the segment, but the segment is not a split test, remove the ID
      campaign.segments[i].percentageSplits.length <= 1 &&
      (campaign.segments[i].splitTestId !== undefined || campaign.segments[i].splitTestId !== '')
    ) {
      campaign.segments[i].splitTestId = undefined;
    }
  }
}
